import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const getRmrAutomations = unaryRpc({
  name: "getRmrAutomations" as const,
  input: z.object({
    teamId: z.string(),
    returnsCenterIds: z.array(z.string()).optional(),
  }),
  output: z.object({
    automationId: z.nullable(z.string()),
    locationsByAccount: z
      .array(
        z.object({
          accountName: z.string(),
          locationNames: z.array(z.string()),
        }),
      )
      .optional(),
  }),
});
